import axios from "axios"
import { IsAuthorized } from "src/authentication/IsAuthorized"
import { getJWT } from "src/helper/localStore/getJWT"

class VoucherServices {
  async getVoucherByHash(hash_item:string): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_NOTIFICATION}/notification/voucher/item/${hash_item}/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async generateVoucher(item:string): Promise<any[]> {
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL_NOTIFICATION}/notification/voucher/`,
        {
          item
        }, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const voucherServices = new VoucherServices()